module.exports = __webpack_public_path__ + "static/media/right-arrow.63f625a0.svg";